export const featuredContent = [
  {
    type: "article",
    slug: "po-vs-pm-agencies",
    date: "08.01.2026",
    readTime: "12 Min.",
    bodyUrl: "/articles/po-vs-pm-agencies.md"
  },
  {
    type: "article",
    slug: "digital-agency-as-a-product",
    date: "16.09.2025",
    readTime: "7 Min.",
    bodyUrl: "/articles/digital-agency-as-a-product.md"
  }
];
